import {
  CANNOT_CONTAIN_DICTIONARY_WORDS,
  CANNOT_CONTAIN_OLD_PASSWORDS,
  PASSWORD_DICTIONARY_ERROR_MESSAGE,
  PASSWORD_UNSECURE_ERROR_MESSAGE,
  UNSECURE_PASSWORD,
  USERNAME_ALREADY_EXISTS,
  USER_NAME_ALREADY_EXIST_ERROR_MESSAGE,
  VALID_PASSWORD,
} from "../../../Constants/AccountSetupConstants";
import {
  API_ACTION_VALIDATE,
  API_ACTION_VERIFY,
  RESPONSE_CODE_200,
  RESPONSE_CODE_406,
} from "../../../Constants/CommonConstants";
import {
  postProviderPassword,
  postProviderUsername,
} from "../../../Features/ProviderAccountCreationSlice";

const passwordSuccessStatus = (passwordApiResponse) => {
  const passedValidations = [];
  if (
    passwordApiResponse === VALID_PASSWORD ||
    passwordApiResponse === UNSECURE_PASSWORD ||
    passwordApiResponse === CANNOT_CONTAIN_OLD_PASSWORDS
  ) {
    passedValidations.push(PASSWORD_DICTIONARY_ERROR_MESSAGE);
  }
  return passedValidations;
};

const passwordErrorStatus = (passwordApiResponse) => {
  if (passwordApiResponse === CANNOT_CONTAIN_DICTIONARY_WORDS) {
    return PASSWORD_DICTIONARY_ERROR_MESSAGE;
  } else if (passwordApiResponse === UNSECURE_PASSWORD) {
    return PASSWORD_UNSECURE_ERROR_MESSAGE;
  }
  return null;
};

const preparePasswordApiResponse = (data) => {
  let passwordApiResponse = "";
  if (data?.message?.code === RESPONSE_CODE_406) {
    passwordApiResponse = data?.error?.message;
  } else if (data?.message?.code === RESPONSE_CODE_200) {
    passwordApiResponse = data?.message?.description;
  }
  return passwordApiResponse;
};

export const verifyUsernameResponse = async (value, dispatch) => {
  const response = await dispatch(
    postProviderUsername({
      data: { userName: value },
      apiAction: API_ACTION_VERIFY,
    })
  );

  const { data } = response.payload;

  if (
    data?.message?.code === RESPONSE_CODE_406 &&
    data?.error?.message === USERNAME_ALREADY_EXISTS
  ) {
    return USER_NAME_ALREADY_EXIST_ERROR_MESSAGE;
  }
  return null;
};

export const validatePasswordResponse = async (
  value,
  dispatch,
  userNameValue,
  userRole
) => {
  const response = await dispatch(
    postProviderPassword({
      data: {
        userName: userNameValue,
        password: value,
        fpactUserType: userRole,
      },
      apiAction: API_ACTION_VALIDATE,
    })
  );

  const { data } = response.payload;

  const passwordApiResponse = preparePasswordApiResponse(data);

  const errorResponse = passwordErrorStatus(passwordApiResponse);
  const successResponse = passwordSuccessStatus(passwordApiResponse);

  return { errorResponse, successResponse };
};
